// ── side-effect: scene override ──
import './scene/root-container-override'

// ── side-effect: 3D factories ──
import './factories/machine-3d'
import './factories/conveyor-3d'
import './factories/agv-3d'
import './factories/oht-3d'
import './factories/shuttle-3d'
import './factories/crane-3d'
import './factories/crane-rail-3d'
// 기본 factory (RealObjectDomTexture) 쓰는 컴포넌트들의 z-priority override
import './factories/z-priority-defaults'

// ── side-effect: @sceneComponent 등록 (tree-shaking 방지) ──
// bars & overlays
import './zone-capacity-bar'
import './stocker-capacity-bar'
import './stocker-carrier-bar'
import './stocker-abnormal-bar'
import './port-flow'

// facilities
import './agv-line'
import './buffer'
import './conveyor'
import './conveyor-join'
import './equipment'
import './oht-line'
import './stocker'
import './crane-rail'
import './scanner'

// vehicles
import './agv'
import './oht'
import './shuttle'

// units
import './port'
import './crane'
import './shelf'
import './carrier'

// topology
import './node'
import './node-path'

// containers
import './floating-container'
import './static-container'
import './clickable-popup'

// ── groups ──
export { default as MachineGroups } from './groups'

// ── base classes ──
export { default as MCSMachine } from './mcs-machine'
export { default as MCSUnit } from './mcs-unit'
export { default as MCSCarrierHolder } from './mcs-carrier-holder'
export { default as MCSVehicle } from './mcs-vehicle'
export { default as MCSTransport } from './mcs-transport'

// ── bars & overlays ──
export { default as ZoneCapacityBar } from './zone-capacity-bar'
export { default as StockerCapacityBar } from './stocker-capacity-bar'
export { default as StockerCarrierBar } from './stocker-carrier-bar'
export { default as StockerAbnormalBar } from './stocker-abnormal-bar'
export { default as PortFlow } from './port-flow'

// ── facilities ──
export { default as AGVLine } from './agv-line'
export { default as Buffer } from './buffer'
export { default as Conveyor } from './conveyor'
export { default as ConveyorJoin } from './conveyor-join'
export { default as Equipment } from './equipment'
export { default as OHTLine } from './oht-line'
export { default as Stocker } from './stocker'
export { default as CraneRail } from './crane-rail'
export { default as Scanner } from './scanner'

// ── vehicles ──
export { default as AGV } from './agv'
export { default as OHT } from './oht'
export { default as Shuttle } from './shuttle'

// ── units ──
export { default as Port } from './port'
export { default as Crane } from './crane'
export { default as Shelf } from './shelf'
export { default as Carrier } from './carrier'

// ── topology ──
export { default as Node } from './node'
export { default as NodePath } from './node-path'

// ── containers ──
export { default as FloatingContainer } from './floating-container'
export { default as StaticContainer } from './static-container'
export { default as ClickablePopup } from './clickable-popup'
